import { useZero } from "@rocicorp/zero/react";
import { useState } from "react";
import { sharedMutators } from "../../../shared/mutators";
import { useHasAccess } from "../../hooks/useHasAccess";
import { Button } from "../Button";
import { EmptyState } from "../EmptyState";
import { useToast } from "../Toast";

export function DraftStorageEmptyState({
  spaceId,
  branchId,
  liveHasVolumes,
  disabled = false,
}: {
  spaceId: string;
  branchId: string;
  liveHasVolumes: boolean;
  disabled?: boolean;
}) {
  const z = useZero();
  const canWrite = useHasAccess("space:write", spaceId);
  const { showToast } = useToast();
  const [copying, setCopying] = useState(false);

  const copy = () => {
    if (disabled || !canWrite) return;
    setCopying(true);
    void z
      .mutate(sharedMutators.seedBranchVolumes({ branchId, from: "live" }))
      .server.then((result) => {
        setCopying(false);
        if (result.type === "error") {
          showToast({
            icon: "circle-off",
            message: result.error.message,
            buttonLabel: "Dismiss",
          });
        }
      });
  };

  return (
    <EmptyState
      iconName="box"
      title="This branch’s storage is empty"
      description={
        liveHasVolumes
          ? "Branches start with empty storage, so they can behave differently from live. Copy live’s storage to test against real data."
          : "Branches start with empty storage. Files this branch stores will appear here."
      }
      action={
        liveHasVolumes ? (
          <Button
            variant="secondary"
            icon="copy"
            disabled={disabled || !canWrite || copying}
            onClick={copy}
          >
            Copy storage from live
          </Button>
        ) : undefined
      }
    />
  );
}
